import { API_URL } from '../../config';
import { getLanguage } from './i18n';

// FIXME: This monkey-patch intercepts window.fetch to inject Accept-Language on every API call.
// It is a stopgap that is functionally redundant with the Accept-Language injection already done
// natively in api.ts sendRequest — it only exists to cover the ~33 raw fetch() calls in action
// files that bypass the centralized helpers. Remove this interceptor once those callers migrate to
// sendRequest. Tracked by follow-up BRAINTECH-5755 (migrate raw fetch() callers to sendRequest);
// introduced for BRAINTECH-5393.
export function initFetchInterceptor() {
  const originalFetch = window.fetch.bind(window);

  window.fetch = (input: RequestInfo | URL, init?: any): Promise<Response> => {
    const url = input instanceof Request ? input.url : input instanceof URL ? input.href : input;

    // Only intercept calls to our backend API
    if (typeof url === 'string' && url.startsWith(API_URL)) {
      const language = getLanguage();

      if (language) {
        const headers = new Headers(init?.headers);

        if (!headers.has('Accept-Language')) {
          headers.set('Accept-Language', language);
        }

        init = { ...init, headers };
      }
    }

    return originalFetch(input, init);
  };
}
